module.exports = __webpack_public_path__ + "static/media/slide-sandal.38d829ca.jpg";